<template>
    <div class="form-panel input" id="payback">
        <div class="form-input">
            <form id="formSimpas" name="formSimpas" method="post">
                <header class="payback-header">
                    <h2>SIMPAS<sup class="reg">®</sup> Equipment Pays for Itself</h2>
                    <div class="row">
                        <p>Estimate how quickly the SIMPAS application system pays for itself.</p>
                    </div>
                </header>
                <div class="content">
                    <div class="row">
                        <label for="planter"><strong>Your Planter Type</strong></label>
                        <select id="planter" name="planter"></select>
                    </div>
                    <div class="row">
                        <label for="numrows"><strong>Number of Rows</strong></label>
                        <select id="numrows" name="numrows">
                            <option value="-1" selected disabled>Select</option>
                            <option value="6">6</option>
                            <option value="8">8</option>
                            <option value="12">12</option>
                            <option value="16">16</option>
                            <option value="24">24</option>
                            <option value="32">32</option>
                        </select>
                    </div>
                </div>
            </form>
        </div>

        <div class="form-results" ref="simpas-results">
            <div class="triangle triangle-payback">
                <svg width="100" height="31" viewBox="0 0 100 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M50 30.3787L1.07281e-05 0.378659L100 0.378662L50 30.3787Z" fill="white"/>
                </svg>
            </div>
            <form name="formSimpas" method="post">
                <div class="content">
                    <div class="row">
                        <label for="totalcost"><strong>SIMPAS System Cost - TOTAL*</strong></label>
                        <div class="totalcost col force-dollarsign">
                            <span class="dollarsign dollarblue">$</span><input type="text" id="totalcost" name="totalcost" tabIndex="-1" readonly>
                        </div>
                    </div>
                    <div class="row">
                        <label for="annualreturn"><strong>Annual Return from Prescriptive Application</strong></label>
                        <div class="col force-dollarsign">
                            <span class="dollarsign dollarblue">$</span><input type="text" id="annualreturn" class="highlighted" name="annualreturn" tabIndex="-1" readonly>
                        </div>
                    </div>
                    <div class="row">
                        <label for="paybacktime"><strong>Estimated Payback Period - years**</strong></label>
                        <div class="col">
                            <input type="text" id="paybacktime" class="highlighted lg" name="paybacktime" tabIndex="-1" readonly>
                        </div>
                    </div>
                </div>
            </form>

            <footer class="content disclaimer">
                <p class="small">*This is only an estimate. Contact a supporting Trimble<sup class="reg">®</sup> dealer for a personalized equipment quote.</p>
                <p class="small">**Estimated Payback Period based on the number of years of total Annual Return from Prescriptive Application of SaS to offset estimated equipment costs.</p>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SimpasForm',
    mounted: function() {

        /*
            SIMPAS Calculator data and formulas based on provided spreadsheet:
            SIMPAS-SB+ ROI Calculator Framework - Dec 3 2020.xlsx
        */

        const universalCosts = [
            {
                name: "System Installation Kit - ALL",
                value: 1500.00
            },
            {
                name: "GFX-750 Display Kit",
                value: 6320.00
            },
            {
                name: "System Cabling-Calibration - 0-12 Rows",
                value: 975.00
            },
            {
                name: "System Cabling-Calibration - 13-16 Rows",
                value: 1100.00
            },
            {
                name: "System Cabling-Calibration - 17-24+ Rows",
                value: 1850.00
            }
        ];

        const universalPerRowCosts = [
            {
                name: "Row Unit Installation Kit",
                value: 1565.00,
                rowOffset: 0
            },
            {
                name: "SIMPAS Granular Meter Kit",
                value: 950.00,
                rowOffset: 0
            },
            {
                name: "SIMPAS RFID Kit",
                value: 360.00,
                rowOffset: 0
            },
            {
                name: "Drop Tube",
                value: 25.00,
                rowOffset: 0
            }
        ];

        const planterSpecificCosts = [
            {
                name: "John Deere Lift Switch",
                value: 50.00
            },
            {
                name: "Case 1200 Lift Switch",
                value: 70.00
            },
            {
                name: "Universal Magnet Lift Switch",
                value: 85.00
            },
            {
                name: "John Deere ME, ME5, EE Ladder Bracket - 2 Rows",
                value: 250.00
            },
            {
                name: "John Deere XP Ladder Bracket - 2 Rows",
                value: 250.00
            },
            {
                name: "Case 1200 Series Ladder Bracket - 2 Rows",
                value: 275.00
            },
            {
                name: "Case 2100 Series Ladder Bracket - 2 Rows",
                value: 275.00
            }
        ];

        const planterSpecificPerRowCosts = [
            {
                name: "Seed Box Row Unit Bracket",
                value: 70.00,
                rowOffset: 0
            },
            {
                name: "John Deere ME, ME5, EE Row Unit Bracket",
                value: 150.00,
                rowOffset: -2
            },
            {
                name: "John Deere XP Row Unit Bracket",
                value: 90.00,
                rowOffset: -2
            },
            {
                name: "Case 1200 Series Row Unit Bracket",
                value: 75.00,
                rowOffset: -2
            },
            {
                name: "Case 2100 Series Row Unit Bracket",
                value: 150.00,
                rowOffset: -2
            }
        ];

        const planters = [
            {
                name: "John Deere ME, ME5, EE Central Fill",
                costs: [
                    universalCosts[0],
                    universalCosts[1],
                    planterSpecificCosts[0],
                    planterSpecificCosts[3]
                ],
                perRowCosts: [
                    universalPerRowCosts[0],
                    universalPerRowCosts[1],
                    universalPerRowCosts[2],
                    universalPerRowCosts[3],
                    planterSpecificPerRowCosts[1]
                ]
            },
            {
                name: "Planter with Seed Boxes",
                costs: [
                    universalCosts[0],
                    universalCosts[1],
                    planterSpecificCosts[2],
                ],
                perRowCosts: [
                    universalPerRowCosts[0],
                    universalPerRowCosts[1],
                    universalPerRowCosts[2],
                    universalPerRowCosts[3],
                    planterSpecificPerRowCosts[0]
                ]
            },
            {
                name: "John Deere XP Central Fill",
                costs: [
                    universalCosts[0],
                    universalCosts[1],
                    planterSpecificCosts[0],
                    planterSpecificCosts[4]
                ],
                perRowCosts: [
                    universalPerRowCosts[0],
                    universalPerRowCosts[1],
                    universalPerRowCosts[2],
                    universalPerRowCosts[3],
                    planterSpecificPerRowCosts[2]
                ]
            },
            {
                name: "Case 1200 Series Central Fill",
                costs: [
                    universalCosts[0],
                    universalCosts[1],
                    planterSpecificCosts[1],
                    planterSpecificCosts[5]
                ],
                perRowCosts: [
                    universalPerRowCosts[0],
                    universalPerRowCosts[1],
                    universalPerRowCosts[2],
                    universalPerRowCosts[3],
                    planterSpecificPerRowCosts[3]
                ]
            },
            {
                name: "Case 2100 Series Central Fill",
                costs: [
                    universalCosts[0],
                    universalCosts[1],
                    planterSpecificCosts[2],
                    planterSpecificCosts[6]
                ],
                perRowCosts: [
                    universalPerRowCosts[0],
                    universalPerRowCosts[1],
                    universalPerRowCosts[2],
                    universalPerRowCosts[3],
                    planterSpecificPerRowCosts[4]
                ]
            },
            {
                name: "Other",
                costs: [
                    universalCosts[0],
                    universalCosts[1],
                    planterSpecificCosts[2],
                    planterSpecificCosts[6]
                ],
                perRowCosts: [
                    universalPerRowCosts[0],
                    universalPerRowCosts[1],
                    universalPerRowCosts[2],
                    universalPerRowCosts[3],
                    planterSpecificPerRowCosts[4]
                ]
            }
        ];


        function calculateLineItemCosts(planterIdx, numRows) {
            const planter = planters[planterIdx];

            const lineItems = {
                planter: planter.name,
                numRows: numRows,
                costs: planter.costs.slice(),
                costsSubTotal: 0.00,
                perRowCosts: planter.perRowCosts.slice(),
                perRowCostsSubTotal: 0.00,
                totalCost: 0.00
            };

            //--- Add system cabling-calibration cost based on number of rows.
            if (numRows <= 12)
                lineItems.costs.push(universalCosts[2]);
            else if (numRows >= 13 && numRows <= 16)
                lineItems.costs.push(universalCosts[3]);
            else if (numRows > 16)
                lineItems.costs.push(universalCosts[4]);

            //--- Calculate per system costs.
            lineItems.costs.forEach(
                function (item) {
                    lineItems.costsSubTotal += item.value;
                }
            );

            //--- Calculate per row costs.
            lineItems.perRowCosts.forEach(
                function (item) {
                    const numItems = numRows + item.rowOffset;
                    const value = item.value * numItems;
                    item.numItems = numItems;
                    item.subTotal = value;
                    lineItems.perRowCostsSubTotal += item.subTotal;
                }
            );

            //--- Calculate total cost.
            lineItems.totalCost = (numRows * 3000);

            return lineItems;
        }

        function calculateTotals(lineItems, totalCost) {
            const totals = {
                lineItems: lineItems,
                totalCost: 0.00,
                annualCost: 0.00,
                perAcreCost: 0.00,
                annualBushelsPerAcre: 0.00
            };

            if (totalCost > 0.00 & totalCost !== lineItems.totalCost)
                totals.totalCost = totalCost;
            else
                totals.totalCost = lineItems.totalCost;

            return totals;
        }

        // FUNCTIONALITY: ---------------------------------------------------------------------------------

        const planterSelect = document.getElementById("planter");
        const numRows = document.getElementById("numrows");
        const totalCost = document.getElementById("totalcost");
        const annualReturn = document.getElementById("annualreturn");
        const paybacktime = document.getElementById("paybacktime");

        function numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        function removeCommas(str) {
            while (str.search(",") >= 0) {
                str = (str + "").replace(',', '');
            }
            return str;
        }

        // Overrride the toFixed function to allow setting precision for accurate rounding down
        function toFixed( num, precision ) {
            return (+(Math.round(+(num + 'e' + precision)) + 'e' + -precision)).toFixed(precision);
        }

        function calculate(useTotalCost) {
            if (planterSelect.value != -1 && numRows.value != -1) {
                // Only run calculation if the user has selected an option for all payment fields

                const lineItems = calculateLineItemCosts(+planterSelect.value, +numRows.value);
                //console.log(lineItems);

                let tc = 0.00;
                if (useTotalCost)
                    tc = +totalCost.value;

                const totalCosts = calculateTotals(lineItems, tc);
                totalCost.value = numberWithCommas( toFixed(totalCosts.totalCost, 2) );

                calculatePaybackTime();

            }
        }

        function calculatePaybackTime() {
            let years = '';
            let yearsRounded = '';
            let theTotalCost = Number(removeCommas(totalCost.value));
            let theAnnualReturn = Number(removeCommas(annualReturn.value));
            if (theTotalCost >= 1 && theAnnualReturn >= 1) {
                years = theTotalCost / theAnnualReturn;
                yearsRounded = toFixed(years, 1);
            }
            paybacktime.value = yearsRounded;
        }

        const calcForm = document.getElementById("formSimpas");
        if (calcForm !== null) {

            const defaultPlanterOption = document.createElement("option");
            defaultPlanterOption.text = 'Select';
            defaultPlanterOption.value = '-1';
            defaultPlanterOption.selected = true;
            defaultPlanterOption.disabled = true;
            planterSelect.add(defaultPlanterOption);

            planters.forEach(
                function (item, index) {
                    const option = document.createElement("option");
                    option.text = item.name;
                    option.value = index;
                    planterSelect.add(option);
                }
            );

            calculate(false);
        }

        planterSelect.addEventListener("change", function () { calculate(false); });
        numRows.addEventListener("input", function () { calculate(false); });
        totalCost.addEventListener("input", function () { calculate(true); });
        annualReturn.addEventListener("change", function () { calculatePaybackTime(); });
    }
}
</script>